
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.01 3.999c.306 0 7.542.01 9.38.514a3.007 3.007 0 012.116 2.115c.467 1.708.493 5.098.494 5.7v.104c0 .224-.015 3.941-.494 5.762a3.007 3.007 0 01-2.116 2.116c-1.758.463-8.455.492-9.302.494h-.177c-.846-.002-7.526-.033-9.303-.514a3.007 3.007 0 01-2.115-2.115c-.45-1.69-.49-5.079-.494-5.68v-.186c.003-.599.044-3.973.494-5.68a3.069 3.069 0 012.115-2.136C4.486 4 11.999 4 11.999 4zM9.606 8.803V16l6.247-3.598-6.247-3.599z","fill":"red"}})])
          )
        }
      }
    